<template>
  <div class="w-full flex items-center justify-start mb-16 text-zt-dark-300">
    <div class="field w-full flex flex-col justify-center rounded bg-zt-dark-200 border-zt-dark-300 pr relative px-3">
      <span class="fake-label absolute bg-zt-dark-200">{{ userInfo.fieldName }}</span>
      <span class="w-full truncate font-medium">{{ userInfo.value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInputValue',
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>

<style scoped lang="scss">
.image-icon {
  width: 80px;
  height: 60px;
}
.field {
  height: 50px;
  border: 1px solid #969696!important;
  .fake-label {
    top: -10px;
    font-size: 0.85rem;
    padding: 1px 5px 0;
  }
  .caret-icon {
    top: 18px;
    right: 15px;
  }
}
.field-auto {
  height: auto!important;
}
.primary-200 {
  color: #4F41A3!important;
  border-color: #4F41A3!important;
}
</style>